<app-toaster #toaster></app-toaster>

<p-dialog
  [visible]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [style]="{ width: '42rem', maxWidth: '95vw' }"
  [breakpoints]="{ '960px': '95vw' }"
  [header]="languageKey.LINK_CHILD_ENTITIES_AFTER_CREATE_TITLE | translateKey"
>
  <div class="flex flex-col gap-5">
    <div class="flex flex-col gap-3">
      <p class="text-sm leading-6 text-slate-600">
        {{
          languageKey.LINK_CHILD_ENTITIES_AFTER_CREATE_DESCRIPTION
            | translateKey
        }}
      </p>

      <div class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
        <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">
          {{ languageKey.CREATED_ITEM | translateKey }}
        </span>
        <div class="mt-1 text-sm font-semibold text-slate-900">
          {{ itemName || itemId }}
        </div>
        <div class="mt-1 text-xs text-slate-500">
          {{ itemTypeKey | translateKey }}
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h3 class="text-sm font-semibold uppercase tracking-wide text-slate-700">
          {{ languageKey.ENTITIES | translateKey }}
        </h3>
        <p class="mt-1 text-sm text-slate-500">
          {{ languageKey.SELECT_CHILD_ENTITIES_TO_LINK | translateKey }}
        </p>
      </div>

      <div class="flex items-center gap-2">
        <p-button
          type="button"
          severity="secondary"
          [outlined]="true"
          size="small"
          [label]="languageKey.SELECT_ALL | translateKey"
          [disabled]="loading || saving || targetEntities.length === 0"
          (click)="selectAll()"
        ></p-button>
        <p-button
          type="button"
          severity="secondary"
          [text]="true"
          size="small"
          [label]="languageKey.CLEAR_SELECTION | translateKey"
          [disabled]="loading || saving || targetEntities.length === 0"
          (click)="clearSelection()"
        ></p-button>
      </div>
    </div>

    <div
      *ngIf="targetEntities.length === 0"
      class="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-sm text-slate-500"
    >
      {{ languageKey.NO_CHILD_ENTITIES_AVAILABLE_FOR_LINKING | translateKey }}
    </div>

    <div
      *ngIf="targetEntities.length > 0"
      class="max-h-80 overflow-y-auto rounded-xl border border-slate-200 bg-white"
    >
      <label
        *ngFor="let entity of targetEntities; let isLast = last"
        class="flex cursor-pointer items-center gap-3 px-4 py-3"
        [class.border-b]="!isLast"
        [style.padding-left.rem]="1 + entity.level * 1.25"
        style="border-color: rgb(226, 232, 240)"
      >
        <p-checkbox
          [binary]="true"
          [ngModel]="isSelected(entity.id)"
          [disabled]="loading || saving"
          (ngModelChange)="toggleEntity(entity.id, $event)"
        ></p-checkbox>
        <div class="flex min-w-0 flex-col">
          <span class="truncate text-sm font-medium text-slate-900">
            {{ entity.name }}
          </span>
        </div>
      </label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
      <p-button
        type="button"
        severity="secondary"
        [outlined]="true"
        [label]="languageKey.SKIP_FOR_NOW | translateKey"
        [disabled]="saving"
        (click)="skip()"
      ></p-button>
      <p-button
        type="button"
        icon="pi pi-check"
        [label]="languageKey.SAVE_LINKS | translateKey"
        [loading]="saving"
        [disabled]="loading || saving || targetEntities.length === 0"
        (click)="save()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
